var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArkimeProdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arkimeProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)",
    fill: "#498084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(-975.336 -206.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arkime_Logo_Mark_Black_2x",
    transform: "translate(998 214.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M38.782-290.627c-.064,1.186-1.8,3.218-3.409,3.938-1.249.572-1.419.551-2.774-.191a17.225,17.225,0,0,0-14-.741,12.2,12.2,0,0,0-1.842.932c-.826.593-1.207.572-2.731-.212a5.541,5.541,0,0,1-2.837-2.9c-.148-.36-.318-.678-.4-.678-.254,0-.4,2.435-.212,3.494.614,3.261,2.139,4.785,7.284,7.305,3.494,1.694,5.018,3.091,6.289,5.738.466.974.847,1.652.847,1.482a9.674,9.674,0,0,1,.762-1.863c1.186-2.393,2.731-3.705,6.585-5.611,2.647-1.313,3.346-1.757,4.531-2.922a6.547,6.547,0,0,0,2.287-5.569,8.765,8.765,0,0,0-.191-2.16C38.8-290.966,38.782-290.966,38.782-290.627Z",
    transform: "translate(-10.491 290.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M36.806-236.12a3.894,3.894,0,0,0,4.108,3.6,5.774,5.774,0,0,0,1.673-.191c.381-.148.318-.275-.741-1.313a13.845,13.845,0,0,0-3.155-2.16L36.7-237.2Z",
    transform: "translate(-31.151 248.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M95.364-235.474c-1.8.91-4.51,3.155-4.171,3.473a6.793,6.793,0,0,0,3.388.106,4.558,4.558,0,0,0,2.647-4.065C97.163-236.342,97.015-236.3,95.364-235.474Z",
    transform: "translate(-74.082 247.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M22.683-216.971a26.936,26.936,0,0,0,.127,6.86,16.27,16.27,0,0,0,.889,2.5c.614,1.376,2.287,3.917,2.5,3.79.064-.021,2.689-1.313,5.823-2.859,5.95-2.943,7.856-4.044,9.444-5.526l.953-.868-1.652.868a13.22,13.22,0,0,1-6.373,1.673,12.9,12.9,0,0,1-10.756-5.59C22.979-217.161,22.81-217.288,22.683-216.971Z",
    transform: "translate(-19.971 232.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M37.682-207.84c-1.059,2.2-3.409,4.447-6.5,6.268-.762.445-3.346,1.715-5.738,2.837-6.86,3.24-9.634,5.315-11.265,8.427a11.3,11.3,0,0,0-1.482,5.992,12.549,12.549,0,0,0,1.927,6.67l.762,1.27.233-1.165a14.708,14.708,0,0,1,1.5-4.235c1.546-3.049,3.705-5.1,9.592-9.1,6.543-4.447,8.872-6.628,10.375-9.825,1.038-2.139,1.757-6.373,1.355-7.792C38.275-209.047,38.254-209.026,37.682-207.84Z",
    transform: "translate(-12.229 226.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M62.819-168.334a18.111,18.111,0,0,1-3.176,4.468,46.578,46.578,0,0,1-7.75,6.077c-4.934,3.324-6.882,5-8.279,7.03a3.156,3.156,0,0,0-.614,2.35c0,4.129,2.393,8.681,6.31,12.027a15.081,15.081,0,0,0,1.652,1.313,6.748,6.748,0,0,0-.169-1.228,22.517,22.517,0,0,1,.466-7.517c.614-2.35,2.922-6.9,5.823-11.54,1.355-2.16,3.028-5.061,3.727-6.458,1.186-2.456,2.435-6.162,2.244-6.712C63.01-168.694,62.9-168.609,62.819-168.334Z",
    transform: "translate(-36.117 194.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkimeProdLogo);
export default __webpack_public_path__ + "static/media/arkimeProdLogo.8c930cf58c7bf1da4cb50dd06917e37b.svg";
export { ForwardRef as ReactComponent };